import type React from 'react';

const handleEnterPress: React.KeyboardEventHandler<HTMLFormElement> = (event) => {
  const target = event.target as HTMLInputElement;
  const { form } = target;

  if (!form) return;

  if (event.key === 'Enter') {
    if (target.nodeName !== 'INPUT') return;

    const index = Array.prototype.indexOf.call(form.elements, target);
    const nextElement = form.elements[index + 1] as HTMLElement | undefined;

    if (nextElement) {
      nextElement.focus();
      event.preventDefault();
    }
  }
};

export default handleEnterPress;
